import './fonts.css';
import './app.css';
import App from './App.svelte';
import { mount } from 'svelte';

type ErrorPayload = { msg: string; stack: string; ua: string; v: string };
const reportedMessages = new Set<string>();
const pendingErrors: ErrorPayload[] = [];

function flushErrorBeacon(): void {
  if (!pendingErrors.length || !navigator.sendBeacon) return;
  const body = pendingErrors.splice(0, pendingErrors.length);
  const endpoint = import.meta.env.VITE_ERROR_LOG_URL || 'https://sampson-swole-elite-api.sampson-projects.workers.dev/api/log';
  navigator.sendBeacon(endpoint, new Blob([JSON.stringify(body)], { type: 'application/json' }));
}

function bufferError(message: unknown, error?: unknown): void {
  const msg = String(message || 'Unknown client error').slice(0, 500);
  if (reportedMessages.has(msg)) return;
  reportedMessages.add(msg);
  const stack = error && typeof error === 'object' && 'stack' in error ? String(error.stack).slice(0, 2000) : '';
  pendingErrors.push({ msg, stack, ua: navigator.userAgent, v: __APP_VERSION__ });
  queueMicrotask(flushErrorBeacon);
}

window.addEventListener('error', event => bufferError(event.message, event.error));
window.addEventListener('unhandledrejection', event => bufferError(event.reason, event.reason));

const app = mount(App, { target: document.getElementById('app')! });

export default app;
